import { make } from "vuex-pathify";
import { getAPI } from "@/store/restAPI.js";
var VueCookie = require("vue-cookie");

// initial state
const state = {
  valuesRetrieved: [], // Translations
  selectedLanguage: VueCookie.get('selectedLanguage') || "es", // Get from cookie or default to 'es'
  loading: false,
};

// getters
const getters = {
  selectedLanguage: (state) => state.selectedLanguage,
  i18nValues: (state) => state.valuesRetrieved,
};

// actions
const actions = {
  loadI18n({ commit, state }) {
    commit("SET_LOADING", true);
    // Use the current selected language from state
    const currentLang = state.selectedLanguage || VueCookie.get('selectedLanguage') || 'es';
    const timestamp = new Date().getTime();
    const random = Math.random().toString(36).substring(7);
    // Use changeI18n endpoint which takes lang parameter
    return getAPI(`i18n/changeI18n?lang=${currentLang}&_t=${timestamp}&_r=${random}`, {}, false, {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    })
      .then(function (response) {
        commit("SET_VALUES_RETRIEVED", response);
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },

  changeI18n({ commit }, language) {
    commit("SET_LOADING", true);
    commit("SET_SELECTED_LANGUAGE", language);
    commit("SET_VALUES_RETRIEVED", {});
    const timestamp = new Date().getTime();
    const random = Math.random().toString(36).substring(7);
    return getAPI(`i18n/changeI18n?lang=${language}&_t=${timestamp}&_r=${random}`, {}, false, {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      'Pragma': 'no-cache',
      'Expires': '0'
    })
      .then(function (response) {
        commit("SET_VALUES_RETRIEVED", response);
      })
      .finally(function () {
        commit("SET_LOADING", false);
      });
  },
};

// mutations
const mutations = {
  ...make.mutations(state),

  SET_SELECTED_LANGUAGE(state, language) {
    state.selectedLanguage = language;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
